module.exports = {
  latlng: [50.9737, 11.03812],
  zoom: 14,
  title: 'Thüringen als Häusermeer',
  introtext:'Wie gut kennen Sie sich in Thüringen wirklich aus? Erkennen Sie diese Gegenden - nur anhand der Gebäudeumrisse? Ordnen Sie den neun Häuserkarten die richtigen Orte zu. Wir geben Ihnen zu jedem Ausschnitt einen kleinen Tipp.',
  resultSentences: [
    'Sie sind höchstens mal durch Thüringen durchgefahren.',
    'Also echter Thüringer sind Sie bestimmt nicht.',
    'Immerhin kennen Sie ein paar Ecken des Landes.',
    'Sie kennen sich gut aus in Thüringen.',
    'Sie kennen Thüringen wie Ihre Westentasche.'
  ],
  questions: [
    {
      id: 'TH 1',
      lat: 50.9316484,
      lng: 11.5868391,
      zoom: 16,
      answers: [
        'Deutsches Optisches Museum',
        'Zeiss-Planetarium',
        'Panorama-Museum'
      ],
      correctAnswer: 'Zeiss-Planetarium',
      description: 'Es ist die weltweit betriebsälteste Einrichtung ihrer Art.'
    },
    {
      id: 'TH 2',
      lat: 50.976269,
      lng: 11.023308,
      zoom: 16,
      answers: [
        'Stadtkirche Sankt Michael Jena',
        'Eichsfelder Dom',
        'Domplatz Erfurt'
      ],
      correctAnswer: 'Domplatz Erfurt',
      description: 'Hier wurde Helmut Kohl 1990 von Zehntausenden gefeiert.'
    },
    {
      id: 'TH 3',
      lat: 50.9287834,
      lng: 11.5854583,
      zoom: 15,
      answers: [
        'Fischmarkt Erfurt',
        'Eichplatz Jena',
        'Kirchplatz Gotha'
      ],
      correctAnswer: 'Eichplatz Jena',
      description: 'Er war früher bekannt als Platz der Kosmonauten.'
    },
    {
      id: 'TH 4',
      lat: 50.9460154,
      lng: 10.7051663,
      zoom: 14,
      answers: [
        'Schloss Friedenstein Gotha',
        'Oberes Schloß Greiz',
        'Barockschloss Brandenstein'
      ],
      correctAnswer: 'Schloss Friedenstein Gotha',
      description: 'Der größte Schlossbau Deutschlands aus dem 17. Jahrhundert.'
    },
    {
      id: 'TH 5',
      lat: 50.9662414,
      lng: 10.3064177,
      zoom: 16,
      answers: [
        'Burg Liebenstein',
        'Wartburg bei Eisenach',
        'Burg Creuzburg'
      ],
      correctAnswer: 'Wartburg bei Eisenach',
      description: 'Luther hat hier laut eigener Aussage „den Teufel mit der Tinte vertrieben“.'
    },
    {
      id: 'TH 6',
      lat: 50.8439034,
      lng: 12.0636083,
      zoom: 14,
      answers: [
        'Gera Lusan',
        'Jena Lobeda',
        'Erfurt Roter Berg'
      ],
      correctAnswer: 'Gera Lusan',
      description: 'Der bevölkerungsreichste Stadtteil dieser Stadt.'
    },
    {
      id: 'TH 7',
      lat: 50.9787939,
      lng: 11.0307124,
      zoom: 16,
      answers: [
        'Lange Brücke Erfurt',
        'Holzbrücke Ilm',
        'Krämerbrücke Erfurt'
      ],
      correctAnswer: 'Krämerbrücke Erfurt',
      description: 'Die längste durchgehend mit Häusern bebaute Brücke Europas.'
    },
    {
      id: 'TH 8',
      lat: 50.9160546,
      lng: 11.5825885,
      zoom: 14,
      answers: [
        'Lotto Thüringen Arena',
        'Steigerwaldstadion',
        'Ernst-Abbe-Sportfeld'
      ],
      correctAnswer: 'Ernst-Abbe-Sportfeld',
      description: 'Heimstädte eines Fußballvereins der 3. Bundesliga.'
    },
    {
      id: 'TH 9',
      lat: 50.8765562,
      lng: 12.0824753,
      zoom: 14,
      answers: [
        'Gera Zentrum',
        'Erfurt Zentrum',
        'Jena Zentrum'
      ],
      correctAnswer: 'Gera Zentrum',
      description: 'Die zugehörige Stadt ist die drittgrößte Thüringens.'
    }
  ]
}